var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "youtube-comments-page" },
    [
      _c("div", { staticClass: "comments-panel" }, [
        _c("div", { staticClass: "panel-header" }, [
          _c("h2", { staticClass: "panel-title" }, [
            _c("span", { staticClass: "material-icons youtube-icon" }, [
              _vm._v("forum"),
            ]),
            _vm._v(
              "\n                " +
                _vm._s(_vm.$t("youtubeChannel.comments")) +
                "\n                "
            ),
            _c("span", { staticClass: "count-badge" }, [
              _vm._v(_vm._s(_vm.total)),
            ]),
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "header-actions" },
            [
              _c(
                "a-select",
                {
                  staticStyle: { width: "200px" },
                  attrs: {
                    placeholder: _vm.$t("youtubeChannel.selectVideo"),
                    size: "small",
                    allowClear: "",
                    showSearch: "",
                    filterOption: _vm.filterVideoOption,
                  },
                  model: {
                    value: _vm.filters.videoId,
                    callback: function ($$v) {
                      _vm.$set(_vm.filters, "videoId", $$v)
                    },
                    expression: "filters.videoId",
                  },
                },
                [
                  _c("a-select-option", { attrs: { value: "" } }, [
                    _vm._v(_vm._s(_vm.$t("youtubeChannel.allVideos"))),
                  ]),
                  _vm._v(" "),
                  _vm._l(_vm.videos, function (video) {
                    return _c(
                      "a-select-option",
                      { key: video.videoId, attrs: { value: video.videoId } },
                      [
                        _vm._v(
                          "\n                        " +
                            _vm._s(_vm._f("truncate")(video.title, 40)) +
                            "\n                    "
                        ),
                      ]
                    )
                  }),
                ],
                2
              ),
              _vm._v(" "),
              _c(
                "a-select",
                {
                  staticStyle: { width: "120px" },
                  attrs: { size: "small" },
                  model: {
                    value: _vm.filters.status,
                    callback: function ($$v) {
                      _vm.$set(_vm.filters, "status", $$v)
                    },
                    expression: "filters.status",
                  },
                },
                [
                  _c("a-select-option", { attrs: { value: "" } }, [
                    _vm._v(_vm._s(_vm.$t("youtubeChannel.all"))),
                  ]),
                  _vm._v(" "),
                  _c("a-select-option", { attrs: { value: "new" } }, [
                    _vm._v(_vm._s(_vm.$t("youtubeChannel.new"))),
                  ]),
                  _vm._v(" "),
                  _c("a-select-option", { attrs: { value: "replied" } }, [
                    _vm._v(_vm._s(_vm.$t("youtubeChannel.replied"))),
                  ]),
                  _vm._v(" "),
                  _c("a-select-option", { attrs: { value: "resolved" } }, [
                    _vm._v(_vm._s(_vm.$t("youtubeChannel.resolved"))),
                  ]),
                ],
                1
              ),
              _vm._v(" "),
              _c("a-input-search", {
                staticStyle: { width: "180px" },
                attrs: {
                  placeholder: _vm.$t("youtubeChannel.searchComments"),
                  size: "small",
                },
                on: { search: _vm.fetchComments },
                model: {
                  value: _vm.filters.search,
                  callback: function ($$v) {
                    _vm.$set(_vm.filters, "search", $$v)
                  },
                  expression: "filters.search",
                },
              }),
              _vm._v(" "),
              _c(
                "a-button",
                {
                  attrs: { size: "small", loading: _vm.loading },
                  on: { click: _vm.fetchComments },
                },
                [_c("a-icon", { attrs: { type: "reload" } })],
                1
              ),
            ],
            1
          ),
        ]),
        _vm._v(" "),
        !_vm.loading
          ? _c(
              "div",
              { staticClass: "comments-list" },
              [
                _vm._l(_vm.comments, function (comment) {
                  return _c(
                    "div",
                    {
                      key: comment._id,
                      staticClass: "comment-item",
                      class: {
                        selected:
                          _vm.selectedComment &&
                          _vm.selectedComment._id === comment._id,
                      },
                      on: {
                        click: function ($event) {
                          return _vm.selectComment(comment)
                        },
                      },
                    },
                    [
                      comment.authorProfileImageUrl
                        ? _c("img", {
                            staticClass: "author-avatar",
                            attrs: { src: comment.authorProfileImageUrl },
                          })
                        : _c(
                            "span",
                            {
                              staticClass: "material-icons avatar-placeholder",
                            },
                            [_vm._v("account_circle")]
                          ),
                      _vm._v(" "),
                      _c("div", { staticClass: "comment-main" }, [
                        _c("div", { staticClass: "comment-top" }, [
                          _c("span", { staticClass: "author-name" }, [
                            _vm._v(_vm._s(comment.authorDisplayName)),
                          ]),
                          _vm._v(" "),
                          _c("span", { staticClass: "comment-date" }, [
                            _vm._v(_vm._s(_vm.formatDate(comment.publishedAt))),
                          ]),
                          _vm._v(" "),
                          _c("span", {
                            staticClass: "status-dot",
                            class: comment.status,
                            attrs: {
                              title: _vm.getStatusLabel(comment.status),
                            },
                          }),
                        ]),
                        _vm._v(" "),
                        _c("p", {
                          staticClass: "comment-text",
                          domProps: {
                            innerHTML: _vm._s(
                              _vm.truncateText(comment.text, 120)
                            ),
                          },
                        }),
                        _vm._v(" "),
                        _c("div", { staticClass: "comment-bottom" }, [
                          _c(
                            "span",
                            { staticClass: "like-info" },
                            [
                              _c("a-icon", { attrs: { type: "like" } }),
                              _vm._v(" " + _vm._s(comment.likeCount || 0)),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          comment.videoTitle
                            ? _c(
                                "span",
                                {
                                  staticClass: "video-link",
                                  on: {
                                    click: function ($event) {
                                      $event.stopPropagation()
                                      return _vm.goToVideo(comment)
                                    },
                                  },
                                },
                                [
                                  _c("a-icon", {
                                    attrs: { type: "play-circle" },
                                  }),
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm._f("truncate")(
                                          comment.videoTitle,
                                          25
                                        )
                                      ) +
                                      "\n                        "
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "comment-actions-mini" },
                        [
                          _c(
                            "a-dropdown",
                            {
                              attrs: { trigger: ["click"] },
                              on: {
                                click: function ($event) {
                                  $event.stopPropagation()
                                },
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "overlay",
                                    fn: function () {
                                      return [
                                        _c(
                                          "a-menu",
                                          [
                                            _c(
                                              "a-sub-menu",
                                              {
                                                key: "status",
                                                attrs: {
                                                  title: _vm.$t(
                                                    "youtubeChannel.status"
                                                  ),
                                                },
                                              },
                                              [
                                                _c(
                                                  "a-menu-item",
                                                  {
                                                    key: "new",
                                                    on: {
                                                      click: function ($event) {
                                                        return _vm.updateStatus(
                                                          comment,
                                                          "new"
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [
                                                    _c("span", {
                                                      staticClass:
                                                        "status-indicator new",
                                                    }),
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(
                                                          _vm.$t(
                                                            "youtubeChannel.new"
                                                          )
                                                        ) +
                                                        "\n                                    "
                                                    ),
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "a-menu-item",
                                                  {
                                                    key: "replied",
                                                    on: {
                                                      click: function ($event) {
                                                        return _vm.updateStatus(
                                                          comment,
                                                          "replied"
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [
                                                    _c("span", {
                                                      staticClass:
                                                        "status-indicator replied",
                                                    }),
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(
                                                          _vm.$t(
                                                            "youtubeChannel.replied"
                                                          )
                                                        ) +
                                                        "\n                                    "
                                                    ),
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "a-menu-item",
                                                  {
                                                    key: "resolved",
                                                    on: {
                                                      click: function ($event) {
                                                        return _vm.updateStatus(
                                                          comment,
                                                          "resolved"
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [
                                                    _c("span", {
                                                      staticClass:
                                                        "status-indicator resolved",
                                                    }),
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(
                                                          _vm.$t(
                                                            "youtubeChannel.resolved"
                                                          )
                                                        ) +
                                                        "\n                                    "
                                                    ),
                                                  ]
                                                ),
                                              ],
                                              1
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "a-sub-menu",
                                              {
                                                key: "moderation",
                                                attrs: {
                                                  title: _vm.$t(
                                                    "youtubeChannel.moderation"
                                                  ),
                                                },
                                              },
                                              [
                                                _c(
                                                  "a-menu-item",
                                                  {
                                                    key: "published",
                                                    on: {
                                                      click: function ($event) {
                                                        return _vm.handleModeration(
                                                          comment,
                                                          "published"
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [
                                                    _c("a-icon", {
                                                      staticStyle: {
                                                        color: "#52c41a",
                                                      },
                                                      attrs: {
                                                        type: "check-circle",
                                                      },
                                                    }),
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(
                                                          _vm.$t(
                                                            "youtubeChannel.publish"
                                                          )
                                                        ) +
                                                        "\n                                    "
                                                    ),
                                                  ],
                                                  1
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "a-menu-item",
                                                  {
                                                    key: "heldForReview",
                                                    on: {
                                                      click: function ($event) {
                                                        return _vm.handleModeration(
                                                          comment,
                                                          "heldForReview"
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [
                                                    _c("a-icon", {
                                                      staticStyle: {
                                                        color: "#faad14",
                                                      },
                                                      attrs: {
                                                        type: "clock-circle",
                                                      },
                                                    }),
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(
                                                          _vm.$t(
                                                            "youtubeChannel.holdForReview"
                                                          )
                                                        ) +
                                                        "\n                                    "
                                                    ),
                                                  ],
                                                  1
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "a-menu-item",
                                                  {
                                                    key: "rejected",
                                                    on: {
                                                      click: function ($event) {
                                                        return _vm.handleModeration(
                                                          comment,
                                                          "rejected"
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [
                                                    _c("a-icon", {
                                                      staticStyle: {
                                                        color: "#ff4d4f",
                                                      },
                                                      attrs: {
                                                        type: "close-circle",
                                                      },
                                                    }),
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(
                                                          _vm.$t(
                                                            "youtubeChannel.reject"
                                                          )
                                                        ) +
                                                        "\n                                    "
                                                    ),
                                                  ],
                                                  1
                                                ),
                                              ],
                                              1
                                            ),
                                            _vm._v(" "),
                                            _c("a-menu-divider"),
                                            _vm._v(" "),
                                            _c(
                                              "a-menu-item",
                                              {
                                                key: "reply",
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.openReplyModal(
                                                      comment
                                                    )
                                                  },
                                                },
                                              },
                                              [
                                                _c("a-icon", {
                                                  attrs: { type: "message" },
                                                }),
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      _vm.$t(
                                                        "youtubeChannel.reply"
                                                      )
                                                    ) +
                                                    "\n                                "
                                                ),
                                              ],
                                              1
                                            ),
                                          ],
                                          1
                                        ),
                                      ]
                                    },
                                    proxy: true,
                                  },
                                ],
                                null,
                                true
                              ),
                            },
                            [
                              _c(
                                "a-button",
                                { attrs: { size: "small", type: "link" } },
                                [_c("a-icon", { attrs: { type: "more" } })],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ]
                  )
                }),
                _vm._v(" "),
                _vm.comments.length === 0
                  ? _c("div", { staticClass: "empty-state" }, [
                      _c("span", { staticClass: "material-icons" }, [
                        _vm._v("chat_bubble_outline"),
                      ]),
                      _vm._v(" "),
                      _c("p", [
                        _vm._v(
                          _vm._s(_vm.$t("youtubeChannel.noCommentsFound"))
                        ),
                      ]),
                    ])
                  : _vm._e(),
              ],
              2
            )
          : _c("div", { staticClass: "loading-state" }, [_c("a-spin")], 1),
        _vm._v(" "),
        _vm.total > _vm.pagination.limit
          ? _c(
              "div",
              { staticClass: "pagination-wrapper" },
              [
                _c("a-pagination", {
                  attrs: {
                    current: _vm.pagination.page,
                    total: _vm.total,
                    "page-size": _vm.pagination.limit,
                    size: "small",
                    "show-size-changer": "",
                    "page-size-options": ["20", "50", "100"],
                  },
                  on: {
                    change: _vm.onPageChange,
                    showSizeChange: _vm.onPageSizeChange,
                  },
                }),
              ],
              1
            )
          : _vm._e(),
      ]),
      _vm._v(" "),
      _vm.selectedVideo
        ? _c("div", { staticClass: "video-panel" }, [
            _c(
              "div",
              { staticClass: "video-header" },
              [
                _c("h3", [_vm._v(_vm._s(_vm.selectedVideo.title))]),
                _vm._v(" "),
                _c(
                  "a-button",
                  {
                    attrs: { type: "link", size: "small" },
                    on: { click: _vm.goToVideoDetail },
                  },
                  [
                    _vm._v(
                      "\n                " +
                        _vm._s(_vm.$t("youtubeChannel.viewDetails")) +
                        " "
                    ),
                    _c("a-icon", { attrs: { type: "arrow-right" } }),
                  ],
                  1
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c("div", { staticClass: "video-embed" }, [
              _c("iframe", {
                attrs: {
                  src:
                    "https://www.youtube.com/embed/" +
                    _vm.selectedVideo.videoId +
                    "?rel=0&modestbranding=1",
                  frameborder: "0",
                  allow:
                    "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture",
                  allowfullscreen: "",
                },
              }),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "video-stats" }, [
              _c("div", { staticClass: "stat" }, [
                _c("span", { staticClass: "material-icons" }, [
                  _vm._v("visibility"),
                ]),
                _vm._v(" "),
                _c("span", [
                  _vm._v(_vm._s(_vm.formatNumber(_vm.selectedVideo.viewCount))),
                ]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "stat" }, [
                _c("span", { staticClass: "material-icons" }, [
                  _vm._v("thumb_up"),
                ]),
                _vm._v(" "),
                _c("span", [
                  _vm._v(_vm._s(_vm.formatNumber(_vm.selectedVideo.likeCount))),
                ]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "stat" }, [
                _c("span", { staticClass: "material-icons" }, [
                  _vm._v("chat_bubble"),
                ]),
                _vm._v(" "),
                _c("span", [
                  _vm._v(
                    _vm._s(_vm.formatNumber(_vm.selectedVideo.commentCount))
                  ),
                ]),
              ]),
            ]),
            _vm._v(" "),
            _vm.selectedComment
              ? _c("div", { staticClass: "selected-comment-detail" }, [
                  _c("div", { staticClass: "detail-header" }, [
                    _vm.selectedComment.authorProfileImageUrl
                      ? _c("img", {
                          attrs: {
                            src: _vm.selectedComment.authorProfileImageUrl,
                          },
                        })
                      : _c("span", { staticClass: "material-icons" }, [
                          _vm._v("account_circle"),
                        ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "author-details" }, [
                      _c("span", { staticClass: "name" }, [
                        _vm._v(_vm._s(_vm.selectedComment.authorDisplayName)),
                      ]),
                      _vm._v(" "),
                      _c("span", { staticClass: "date" }, [
                        _vm._v(
                          _vm._s(
                            _vm.formatDate(_vm.selectedComment.publishedAt)
                          )
                        ),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "badges" }, [
                      _c(
                        "span",
                        {
                          staticClass: "status-badge",
                          class: _vm.selectedComment.status,
                        },
                        [
                          _vm._v(
                            _vm._s(
                              _vm.getStatusLabel(_vm.selectedComment.status)
                            )
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _vm.selectedComment.moderationStatus
                        ? _c(
                            "span",
                            {
                              staticClass: "moderation-badge",
                              class: _vm.selectedComment.moderationStatus,
                            },
                            [
                              _vm._v(
                                "\n                        " +
                                  _vm._s(
                                    _vm.getModerationLabel(
                                      _vm.selectedComment.moderationStatus
                                    )
                                  ) +
                                  "\n                    "
                              ),
                            ]
                          )
                        : _vm._e(),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", {
                    staticClass: "detail-body",
                    domProps: { innerHTML: _vm._s(_vm.selectedComment.text) },
                  }),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "detail-actions" },
                    [
                      _c(
                        "a-button",
                        {
                          attrs: { size: "small", type: "primary" },
                          on: {
                            click: function ($event) {
                              return _vm.openReplyModal(_vm.selectedComment)
                            },
                          },
                        },
                        [
                          _c("a-icon", { attrs: { type: "message" } }),
                          _vm._v(
                            " " +
                              _vm._s(_vm.$t("youtubeChannel.reply")) +
                              "\n                "
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "a-dropdown",
                        {
                          attrs: { trigger: ["click"] },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "overlay",
                                fn: function () {
                                  return [
                                    _c(
                                      "a-menu",
                                      {
                                        on: {
                                          click: function (e) {
                                            return _vm.updateStatus(
                                              _vm.selectedComment,
                                              e.key
                                            )
                                          },
                                        },
                                      },
                                      [
                                        _c("a-menu-item", { key: "new" }, [
                                          _vm._v(
                                            _vm._s(_vm.$t("youtubeChannel.new"))
                                          ),
                                        ]),
                                        _vm._v(" "),
                                        _c("a-menu-item", { key: "replied" }, [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t("youtubeChannel.replied")
                                            )
                                          ),
                                        ]),
                                        _vm._v(" "),
                                        _c("a-menu-item", { key: "resolved" }, [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t("youtubeChannel.resolved")
                                            )
                                          ),
                                        ]),
                                      ],
                                      1
                                    ),
                                  ]
                                },
                                proxy: true,
                              },
                            ],
                            null,
                            false,
                            782850779
                          ),
                        },
                        [
                          _c(
                            "a-button",
                            { attrs: { size: "small" } },
                            [
                              _vm._v(
                                _vm._s(_vm.$t("youtubeChannel.status")) + " "
                              ),
                              _c("a-icon", { attrs: { type: "down" } }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "a-dropdown",
                        {
                          attrs: { trigger: ["click"] },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "overlay",
                                fn: function () {
                                  return [
                                    _c(
                                      "a-menu",
                                      {
                                        on: {
                                          click: function (e) {
                                            return _vm.handleModeration(
                                              _vm.selectedComment,
                                              e.key
                                            )
                                          },
                                        },
                                      },
                                      [
                                        _c(
                                          "a-menu-item",
                                          { key: "published" },
                                          [
                                            _c("a-icon", {
                                              staticStyle: { color: "#52c41a" },
                                              attrs: { type: "check-circle" },
                                            }),
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  _vm.$t(
                                                    "youtubeChannel.publish"
                                                  )
                                                ) +
                                                "\n                            "
                                            ),
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "a-menu-item",
                                          { key: "heldForReview" },
                                          [
                                            _c("a-icon", {
                                              staticStyle: { color: "#faad14" },
                                              attrs: { type: "clock-circle" },
                                            }),
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  _vm.$t(
                                                    "youtubeChannel.holdForReview"
                                                  )
                                                ) +
                                                "\n                            "
                                            ),
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "a-menu-item",
                                          { key: "rejected" },
                                          [
                                            _c("a-icon", {
                                              staticStyle: { color: "#ff4d4f" },
                                              attrs: { type: "close-circle" },
                                            }),
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  _vm.$t(
                                                    "youtubeChannel.reject"
                                                  )
                                                ) +
                                                "\n                            "
                                            ),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                  ]
                                },
                                proxy: true,
                              },
                            ],
                            null,
                            false,
                            3247180806
                          ),
                        },
                        [
                          _c(
                            "a-button",
                            { attrs: { size: "small" } },
                            [
                              _vm._v(
                                _vm._s(_vm.$t("youtubeChannel.moderation")) +
                                  " "
                              ),
                              _c("a-icon", { attrs: { type: "down" } }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ])
              : _vm._e(),
          ])
        : _c("div", { staticClass: "video-panel empty" }, [
            _c("span", { staticClass: "material-icons" }, [
              _vm._v("smart_display"),
            ]),
            _vm._v(" "),
            _c("p", [
              _vm._v(_vm._s(_vm.$t("youtubeChannel.selectCommentToPreview"))),
            ]),
          ]),
      _vm._v(" "),
      _c(
        "a-modal",
        {
          attrs: {
            title: _vm.$t("youtubeChannel.replyToComment"),
            "confirm-loading": _vm.replyModal.loading,
            width: "500px",
          },
          on: { ok: _vm.submitReply },
          model: {
            value: _vm.replyModal.visible,
            callback: function ($$v) {
              _vm.$set(_vm.replyModal, "visible", $$v)
            },
            expression: "replyModal.visible",
          },
        },
        [
          _vm.replyModal.comment
            ? _c("div", { staticClass: "reply-preview" }, [
                _vm.replyModal.comment.authorProfileImageUrl
                  ? _c("img", {
                      attrs: {
                        src: _vm.replyModal.comment.authorProfileImageUrl,
                      },
                    })
                  : _vm._e(),
                _vm._v(" "),
                _c("div", [
                  _c("strong", [
                    _vm._v(_vm._s(_vm.replyModal.comment.authorDisplayName)),
                  ]),
                  _vm._v(" "),
                  _c("p", {
                    domProps: {
                      innerHTML: _vm._s(
                        _vm.truncateText(_vm.replyModal.comment.text, 200)
                      ),
                    },
                  }),
                ]),
              ])
            : _vm._e(),
          _vm._v(" "),
          _c("a-textarea", {
            attrs: {
              placeholder: _vm.$t("youtubeChannel.writeYourReply"),
              rows: 4,
              maxLength: 10000,
            },
            model: {
              value: _vm.replyModal.text,
              callback: function ($$v) {
                _vm.$set(_vm.replyModal, "text", $$v)
              },
              expression: "replyModal.text",
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }